import { useState, useEffect } from "react";

const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

interface CarouselLogoEntry {
  id: number;
  name: string;
  imageData: string | null;
  sortOrder: number;
  active: boolean;
}

export function LogoCarousel() {
  const [logos, setLogos] = useState<CarouselLogoEntry[]>([]);

  useEffect(() => {
    fetch(`${BASE}/api/carousel-logos`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data)) setLogos(data);
      })
      .catch(() => {});
  }, []);

  const allLogos = [...logos, ...logos];

  if (logos.length === 0) return null;

  return (
    <div className="w-full py-10">
      <div
        className="relative overflow-hidden"
        style={{
          WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
          maskImage: "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
        }}
      >
        <div
          className="flex items-center gap-[110px]"
          style={{ animation: "marquee 10s linear infinite", width: "max-content" }}
        >
          {allLogos.map((logo, i) => (
            <div
              key={i}
              className="flex items-center gap-3 shrink-0 opacity-80 hover:opacity-100 transition-all duration-300 cursor-default"
              title={logo.name}
            >
              {logo.imageData ? (
                <img
                  src={logo.imageData}
                  alt={logo.name}
                  className="h-[56px] w-auto max-w-[130px] object-contain"
                />
              ) : (
                <span className="font-bold text-[30px] text-slate-300" style={{ fontFamily: "Inter, sans-serif" }}>
                  {logo.name}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
